import React, { FC } from 'react';
import { Container } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { observer } from 'mobx-react-lite';
import { DashboardHeader } from 'src/UIKit/DashboardHeader';
import { ForceUpdateTable } from '../components/table';

export const ForceUpdateView: FC = observer(() => {
    const { t } = useUiContext();

    return (
        <Container maxWidth="xl">
            <DashboardHeader title={t("force_update.force_update")} view='force_update'/>
            <ForceUpdateTable />
        </Container>
    );
});
